import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "../WorkoutAdminModal.module.css";

export default function PlanModal({
  closePlanModal,
  planModalRef,
  editingPlanId,
  handleSavePlan,
  planForm,
  setPlanForm,
  saving,
}) {
  return (
    <div className={styles.innerOverlay} onClick={closePlanModal}>
                      <div
                        className={styles.planModal}
                        ref={planModalRef}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="wam-plan-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div className={styles.planModalHeader}>
                          <div>
                            <h3 id="wam-plan-title">{editingPlanId ? "Editar treino" : "Criar treino"}</h3>
                            <p>
                              {editingPlanId
                                ? "Atualize as informações principais do treino."
                                : "Preencha os dados principais para criar um novo treino."}
                            </p>
                          </div>

                          <button
                            type="button"
                            className={styles.planModalClose}
                            onClick={closePlanModal}
                            aria-label="Fechar modal"
                          >
                            <FontAwesomeIcon icon={faXmark} />
                          </button>
                        </div>

                        <form className={styles.wamForm} onSubmit={handleSavePlan}>
                          <div className={styles.wamField}>
                            <label>Título</label>
                            <input
                              type="text"
                              value={planForm.title}
                              onChange={(e) =>
                                setPlanForm((prev) => ({ ...prev, title: e.target.value }))
                              }
                              placeholder="Ex: Plano A"
                              required
                            />
                          </div>

                          <div className={styles.wamField}>
                            <label>Descrição</label>
                            <textarea
                              rows="4"
                              value={planForm.description}
                              onChange={(e) =>
                                setPlanForm((prev) => ({ ...prev, description: e.target.value }))
                              }
                              placeholder="Resumo do treino"
                            />
                          </div>

                          <label className={styles.wamCheck}>
                            <input
                              type="checkbox"
                              checked={!!planForm.is_blank}
                              onChange={(e) =>
                                setPlanForm((prev) => ({ ...prev, is_blank: e.target.checked }))
                              }
                            />
                            <span>Treino em branco</span>
                          </label>

                          <label className={styles.wamCheck}>
                            <input
                              type="checkbox"
                              checked={planForm.is_active}
                              onChange={(e) =>
                                setPlanForm((prev) => ({ ...prev, is_active: e.target.checked }))
                              }
                            />
                            <span>Treino ativo</span>
                          </label>

                          <div className={styles.actionsRow}>
                            <button
                              type="button"
                              className={`${styles.wamBtn} ${styles.ghost}`}
                              onClick={closePlanModal}
                              disabled={saving}
                            >
                              Cancelar
                            </button>

                            <button
                              type="submit"
                              className={`${styles.wamBtn} ${styles.primary}`}
                              disabled={saving}
                            >
                              {editingPlanId ? "Salvar treino" : "Criar treino"}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
  );
}
